import useSWR from 'swr';
import { usersApi } from 'packages/lib/api/annotations-ops/clients';
import { User } from 'packages/lib/api/annotations-ops/contract';

export function useUsers() {
  return useSWR('users', () => usersApi.list());
}

export function useCurrentUser() {
  return useSWR('current-user', () => usersApi.getCurrent());
}

export function useUserHistory(user: User | null | undefined) {
  return useSWR(
    user ? ['user-history', user.user_id, user.updated_at] : null,
    ([, userId]) => usersApi.history.get(userId)
  );
}
